var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroPageWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1915,
    height: 835,
    viewBox: "0 0 1915 835",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-146 692.034C-146 692.034 97.0426 351.609 430.64 660.562C764.238 969.515 1098.99 809.587 1261.6 548.703C1424.2 287.819 1708.46 155.345 1872.26 581.926C2036.07 1008.51 1995.72 -100.578 2404.46 -141",
    stroke: "url(#paint0_linear_3765_1477)",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3765_1477",
    x1: 1033.28,
    y1: 1046.3,
    x2: 1288.71,
    y2: -345.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPageWire);
export default __webpack_public_path__ + "static/media/hero_page_wire.e7b3245fc02129a74e12926b72761139.svg";
export { ForwardRef as ReactComponent };